import React, { useState } from 'react';
import { Modal, Input, Radio } from 'antd';
import { FOLDER_COLORS, Visibility } from 'mock/folder.data';

interface Props {
  open: boolean;
  onClose: () => void;
  onConfirm: (name: string, colorId: string, visible: Visibility) => Promise<void> | void;
  onReload: () => void;
}

const NewFolderModal: React.FC<Props> = ({ open, onClose, onConfirm, onReload }) => {
  const [name, setName] = useState('');
  const [colorId, setColorId] = useState('3');
  const [visible, setVisible] = useState<Visibility>('private');

  const resetForm = () => {
    setName('');
    setColorId('3');
    setVisible('private');
  };

  const handleOk = async () => {
    if (!name.trim()) return;

    await Promise.resolve(onConfirm(name.trim(), colorId, visible));
    resetForm();
    onReload();
    onClose();
  };

  const handleCancel = () => {
    resetForm();
    onClose();
  };

  return (
    <Modal
      title="Thư mục mới"
      open={open}
      onOk={handleOk}
      onCancel={handleCancel}
      okText="Tạo thư mục"
      cancelText="Hủy"
      okButtonProps={{ disabled: !name.trim() }}
      width={440}
    >
      <div className="new-folder-modal">
        <div className="new-folder-modal__field">
          <label className="new-folder-modal__label">Tên thư mục</label>
          <Input
            placeholder="Nhập tên thư mục..."
            value={name}
            onChange={(e) => setName(e.target.value)}
            onPressEnter={handleOk}
            autoFocus
            maxLength={80}
          />
        </div>

        <div className="new-folder-modal__field">
          <label className="new-folder-modal__label">Màu sắc</label>
          <div className="new-folder-modal__colors">
            {Object.entries(FOLDER_COLORS).map(([key, { startColor }]) => (
              <div
                key={key}
                className={`new-folder-modal__color-dot${colorId === key ? ' new-folder-modal__color-dot--active' : ''}`}
                style={{ backgroundColor: startColor }}
                onClick={() => setColorId(key)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => e.key === 'Enter' && setColorId(key)}
                title={`Màu ${key}`}
              />
            ))}
          </div>
        </div>

        {/* <div className="new-folder-modal__field">
          <label className="new-folder-modal__label">Trạng thái</label>
          <Radio.Group value={visible} onChange={(e) => setVisible(e.target.value)}>
            <Radio value="public">Công khai</Radio>
            <Radio value="private">Riêng tư</Radio>
          </Radio.Group>
        </div> */}
      </div>
    </Modal>
  );
};

export default NewFolderModal;
